export const listChains = async params => {
  return await window.$vue.$get({ endpoint: "/chain", params })
}

export const listActiveChains = async params => {
  return await window.$vue.$get({ endpoint: "/chain/list-all", params })
}

export const listChainsFromId = async params => {
  return await window.$vue.$get({
    endpoint: "/chain/list-all",
    params
  })
}

export const changeStatus = async (uuid, data) => {
  return await window.$vue.$put({
    endpoint: `/chain/change-status/${uuid}`,
    data
  })
}

export const editChain = async (uuid, data) => {
  return await window.$vue.$post({
    endpoint: `/chain/${uuid}`,
    data,
    headers: {
      "Content-Type": "multipart/form-data"
    }
  })
}

export const fetchChain = async uuid => {
  return await window.$vue.$get({ endpoint: `/chain/${uuid}` })
}

export const createChain = async data => {
  return await window.$vue.$post({
    endpoint: "/chain",
    data,
    headers: {
      "Content-Type": "multipart/form-data"
    }
  })
}

export const getAllChain = async () => {
  return await window.$vue.$get({
    endpoint: "/chain/list-all"
  })
}
